import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

function MonthlyRevenueChart({ chart_data }) {
  const [data, setData] = useState({});
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  // ✅ Month order (IMPORTANT)
  const monthOrder = [
    "April","May","June","July","August","September",
    "October","November","December","January","February","March"
  ];

  // ✅ Prepare dropdown
  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    const yearList = chart_data.map(item => item.year);

    setYears(yearList);

    // ✅ Default latest (first item assumed latest based on your data)
    setSelectedYear(yearList[0]);

  }, [chart_data]);

  // ✅ Prepare chart
  useEffect(() => {
    if (!selectedYear) return;

    const selectedData = chart_data.find(
      item => item.year === selectedYear
    );

    if (!selectedData) return;

    const labels = monthOrder;

    // ✅ Revenue (convert to Cr)
    const revenueData = monthOrder.map(month =>
      Number(((selectedData[month] || 0) / 10000000).toFixed(2))
    );

    // ✅ Fixed Target = 20 Cr
    const targetData = labels.map(() => 20);

    setData({
      labels,
      datasets: [
        {
          label: "Target (20 Cr)",
          data: targetData,
          backgroundColor: "#f6ab49",
          borderRadius: 6,
        },
        {
          label: "Revenue",
          data: revenueData,
          backgroundColor: "#36A2EB",
          borderRadius: 6,
        },
      ],
    });

  }, [selectedYear, chart_data]);

  return (
    <div style={{ width: "100%" }}>
      
      {/* ✅ Dropdown */}
      <div style={{ marginBottom: "10px" }}>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {/* ✅ Chart */}
      <div style={{ width: "100%", height: "300px" }}>
        {data?.datasets && (
          <Chart
            type="bar"
            data={data}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: "top" },
                tooltip: {
                  callbacks: {
                    label: (context) =>
                      `${context.dataset.label}: ₹ ${context.raw} Cr`,
                  },
                },
              },
              scales: {
                y: {
                  ticks: {
                    callback: (value) => `₹ ${value} Cr`,
                  },
                },
              },
            }}
          />
        )}
      </div>
    </div>
  );
}

export default MonthlyRevenueChart;